/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  downDocuments({ commit }, name) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/downdocument/${name}`)
        .then((response) => {
          // console.log('bizaaaaaaaaaar',response.data)
          // commit('SET_FORMATEUR', response.data)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFormateur({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formateur_classes_id/${userId}`)
        .then((response) => {
          console.log('bizaaaaaaaaaar',response.data)
          commit('SET_FORMATEUR', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removedocument({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/remove_document/${userId}`)
        .then((response) => {
          console.log(response.data)
          commit('REMOVE_DOCUMENT', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCandidatsAjouter({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_candidat_classes_id_ajouter/${userId}`)
        .then((response) => {
          console.log(response.data)
          commit('SET_CANDIDAT', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCandidats({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_candidat_classes_id/${userId}`)
        .then((response) => {
          console.log(response.data)
          commit('SET_CANDIDAT', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchSeances({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_seances_classe_id/${userId}`)
        .then((response) => {
          console.log("responsexccccccccccccccc",response.data)
          commit('SET_SEANCES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addParticpation_formateur_class({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("https://trainingcenterback.codily.net/api/add_rembourser_formateur_formation", item)
        
        .catch((error) => { reject(error) })
    })
  },
   addItem({ commit }, item) {
     return new Promise((resolve, reject) => {
       axios.post("https://trainingcenterback.codily.net/api/add_classe", item)
         .then((response) => {
           commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
           resolve(response)
         })
         .catch((error) => { reject(error) })
     })
   },
  fetchUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/get_classe")
        .then((response) => {
          
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classe_id/${userId}`)
        .then((response) => {
          console.log('fefefef',response.data)
          // commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`https://trainingcenterback.codily.net/api/destroyclasse/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateParticipation_candidat_formation({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/update_participation_candidat_formation/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateRembourser_formateur_formation({ commit }, user) {
    
    return new Promise((resolve, reject) => {
      
      axios.post(`https://trainingcenterback.codily.net/api/update_rembourser_formateur_formation/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          
          let user = response.data
          // commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateRecord({ commit }, user) {
    
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/update_classe/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  ////////////********** */
  fetchClassesFormateur({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classe_formateur_id/${userId}`)
        .then((response) => {
          console.log('userId',userId)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchClassesID({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classe_id/${userId}`)
        .then((response) => {
          console.log('xxuserId',userId)
          console.log('xxresponse.data',response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  ////////////***Candidat******* */
  fetchClassesCandidat({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classe_candidat_id/${userId}`)
        .then((response) => {
          console.log(response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchClasseDocuments({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classe_documents_id/${userId}`)
        .then((response) => {
         
          commit('SET_DOCUMENTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addDocuments({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("https://trainingcenterback.codily.net/api/add_document", item)
        .then((response) => {
          console.log(response);
          // commit('ADD_DOCUMENT', Object.assign(response.data, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addParticipation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("https://trainingcenterback.codily.net/api/add_participation_candidat_formation", item)
        .then((response) => {
          //commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
 
  fetchBilan_c({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_participations`)
        .then((response) => {
          commit('SET_BILANC', response.data)
          console.log('ccccccccc')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchBilan_f({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_remboursers`)
        .then((response) => {
          console.log('fffffffff',response.data)
          commit('SET_BILANF', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchBilan_f_formateur({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_remboursers_formateur/${userId}`)
        .then((response) => {
          commit('SET_BILANF', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeParticipationCandidatFormation({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/removeParticipationCandidatFormation/${user.id}/${user.candidat_id}/${user.classe_id}`)
        .then((response) => {
          commit('REMOVE_PARTICIPATION', user.id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
}
